import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Stack,
  alpha,
  Button,
  Collapse,
  useTheme,
  Skeleton,
  Divider,
} from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { formatAmount } from "../../../utils/hooks/dataHandler";
import ExpandedArrowBox from "../../Common/ExpandedArrowBox";

const DetailsContainer = ({
  id,
  title,
  onAdd,
  showAddButton = false,
  totalAmount,
  children,
  icon: Icon,
  loading = false,
  showDecimal = false,
  rows,
}) => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(true);

  return (
    <Paper
      id={id}
      elevation={0}
      sx={{
        mb: 3,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
        },
      }}
    >
      {/* Header */}
      <Stack
        direction='row'
        alignItems='center'
        spacing={2}
        sx={{
          px: 3,
          py: 2,
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.03),
          borderBottom: "1px solid",
          borderColor: "divider",
          cursor: "pointer",
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 2,
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
          }}
        >
          {Icon ? (
            <Icon color='primary' />
          ) : (
            <ReceiptLongIcon color='primary' />
          )}
        </Box>
        <Box flex={1}>
          <Typography variant='h6' fontWeight={600} color='text.primary'>
            {title}
          </Typography>
        </Box>
        <Stack direction='row' spacing={2} alignItems='center'>
          <Stack direction='row' spacing={1} alignItems='center'>
            {loading ? (
              <Skeleton width={100} height={48} />
            ) : (
              <Typography
                variant='h6'
                fontWeight={600}
                sx={{
                  fontWeight: 600,
                  color:
                    totalAmount < 0
                      ? theme.palette.error.main
                      : theme.palette.success.main,
                  textAlign: "right",
                }}
              >
                {formatAmount(totalAmount, !showDecimal)}
              </Typography>
            )}
          </Stack>

          <ExpandedArrowBox expanded={expanded} />
        </Stack>
      </Stack>

      <Collapse in={expanded}>
        <Box>
          {children}

          {showAddButton || (rows && rows > 0) ? (
            <Stack
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              spacing={2}
              sx={{
                p: 2,
                px: 3,
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.02),
              }}
            >
              <Typography
                variant='body2'
                color='text.secondary'
                sx={{ ml: "auto", mr: 2 }}
              >
                {rows ? `${rows} rows` : ""}
              </Typography>

              {showAddButton && (
                <Button
                  onClick={onAdd}
                  variant='outlined'
                  color='primary'
                  startIcon={<AddCircleOutlineIcon />}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                  }}
                >
                  Add Row
                </Button>
              )}
            </Stack>
          ) : (
            <></>
          )}
        </Box>
      </Collapse>
    </Paper>
  );
};

export default DetailsContainer;
